import React from 'react';
import { useEffect, useState } from 'react';
import './ChickenPage.css';
import Button from './Button';
import AnimeChicken from './AnimeChicken.js';
import { useParams, Link } from "react-router-dom";


function Galary(props) {
  //const [metadata, setMetadata] = useState(null);
  const API = props.api;
  useEffect(() => {
    API.fetchLatestTokenId()
  }, []);

  const listItems = Array(API.latestTokenId + 1).fill(0).map((_, i) =>
    <div className="pure-u-1 pure-u-md-1-3 pure-u-lg-1-4 pure-u-xl-1-5" key={i.toString()} >
      <div style={{ margin: '10px' }}>
        <Link to={`/${i}`}>
          <Button>
            <div>
              <img src={`/images/${i}.png`} style={{ height: '100px' }} /> <br /> {`Chicken #${i}`}
            </div>
          </Button>
        </Link>
      </div>
    </div>

  );

  return (
    <div>

      <AnimeChicken tokenId={''} >
        <div style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          overflow: 'scroll',
          zIndex: 999
        }}>
          <h1>Gallery</h1>
          <div className="pure-g">
            {listItems}
          </div>
        </div>
      </AnimeChicken>

    </div>
  )
}

export default Galary;
